module.exports = __webpack_public_path__ + "static/media/info-btn-1.f5803330.jpg";